import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { OutputService } from '../../../infrastructure/services/output.service';
import { Location } from '@angular/common';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { QueryBuilderConfig } from 'app/plugins/queryBuilder';
import { RuleBuilderService, EmptyRuleBuilder } from 'app/infrastructure/services/ruleBuilder.service';
import { INgxSelectOption } from 'ngx-select-ex';
import { FieldMap } from 'app/plugins/queryBuilder/components';
import { OperationPrototypes, RulePrototypeMethod } from 'app/infrastructure/model/interfaces/rulePrototype.interface';
import { ProductEmailAttribute } from 'app/infrastructure/model/classes/productEmail.class';


export interface MappedAttribute {
    id?: number;
    attribute?: string;
    type?: string;
    mappingRule?: string;
}

@Component({
    selector: 'sx-mapping-attribute',
    templateUrl: './mappingAttribute.component.html',
})
export class MappingAttributeComponent implements OnInit {

    editorOptions: any = { maxLines: 1000, printMargin: true };
    newConst = 'new';

    targetSelectConfig = {
        displayKey: 'description',
        search: true,
        limitTo: 20
    };

    @Input() fields: FieldMap;
    @Input() selectedSource: string;
    @Input() attributeConst: string;
    @Input() mappingId: string;
    @Input() sources: string[] = [];
    @Input() attribute: MappedAttribute;
    @Input('rule')
    set rule(valu: string) {
        if (valu) {
            this._rule = valu;
        } else {
            this._rule = '';
        }
    }

    _rule: string;
    @Output() ruleConfig: EventEmitter<string> = new EventEmitter();

    targetKeys = [];
    targetFields = [];

    operationTypes = OperationPrototypes;

    constructor(
    ) { }

    ngOnInit() {
        this.prepareTargetFields(this.fields);
        this.setTargetBySource(this.selectedSource);
    }


    onPrototypeClick(rule: RulePrototypeMethod): void {
        this.appendToRule(rule.prototype);
        this.ruleConfig.emit(this._rule);
    }

    onTargetSelect(target) {
        let selectedTarget = '';
        if (target !== undefined) {
            if (this.attributeConst) {
                if (this.selectedSource !== this.attributeConst) {
                    selectedTarget = `{${this.selectedSource}.${target}}`;
                } else {
                    selectedTarget = `{${this.attributeConst}.${target}}`;
                }
            } else {
                selectedTarget = `{${target}}`;
            }
            this.appendToRule(selectedTarget);
        }
        this.ruleConfig.emit(this._rule);
    }

    appendToRule(value) {
        if (this._rule !== null) {
            this._rule += value;
        } else {
            this._rule = value;
        }
    }

    setTargetBySource(source) {
        let selectedTarget = this.targetKeys.find(t => t.type === source)
        if(selectedTarget){
            this.targetFields = selectedTarget.fields;
        }
    }

    prepareTargetFields(fields) {
        const attributeId = (this.mappingId === this.newConst ? 0 : +this.mappingId);
        this.sources.forEach(source => {
            let selectFields = [];

            selectFields = fields.filter(f => f.entity === source).map(f => f.name);

            this.targetKeys.push({
                type: source,
                fields: selectFields
            });
        });
    }

    onChange(value) {
        this._rule = value;
        this.ruleConfig.emit(this._rule);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/mappingAttribute/mappingAttribute.component.ts